<template>
  <RecordListPreview v-bind="previewProps" empty-label="专家咨询" />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import RecordListPreview from '../../RecordListPreview.vue'
import type { WidgetPreviewProps } from '../../types'

const props = defineProps<WidgetPreviewProps>()
const previewProps = computed(() => props)
</script>
